<nav class="navbar sticky-top border-bottom aic-landing-nav py-3">
  <div class="container">
    <router-link to="/login" class="navbar-brand d-flex align-items-center gap-3 m-0" aria-label="Department of Basic Education login">
      <span class="auth-logo auth-logo-navbar d-block" aria-hidden="true"></span>
      <span class="aic-landing-brand-copy d-none d-sm-block ps-3 border-start fw-semibold text-uppercase">Department of Basic Education</span>
    </router-link>

    <router-link to="/login" class="btn aic-landing-nav-btn px-4">
      Sign in <i class="bi bi-arrow-up-right ms-2"></i>
    </router-link>
  </div>
</nav>
